import React, { useEffect, useState } from "react";

import { twoFAApi } from "../../services/twoFAServices";
import Loader from "../Loader";
import TwoFAForm from "./TwoFAForm";

const TwoFASetupForm = ({
  onSubmit,
  onClose,
  userId,
  defaultTwoFASetup,
}) => {
  const [twoFASetup, setTwoFASetup] = useState(defaultTwoFASetup || null);
  const [loading, setLoading] = useState(!defaultTwoFASetup);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!twoFASetup) {
      const fetchSetup = async () => {
        setLoading(true);
        try {
          const result = await twoFAApi.setup();
          setTwoFASetup(result);
        } catch (err) {
          setError("There was an error setting up 2FA. Please try again.");
        } finally {
          setLoading(false);
        }
      };
      fetchSetup();
    }
  }, [twoFASetup]);

  if (loading || !twoFASetup) {
    return <Loader size="sm" />;
  }

  if (error) {
    return <p className="text-danger text-center">{error}</p>;
  }

  return (
    <div className="d-flex flex-column align-items-center">
      <h5 className="mb-2">Enable 2FA</h5>
      <p className="mb-0 text-center">
        Scan this QR code with a TOTP app (e.g. Google Authenticator):
      </p>
      <img
        src={twoFASetup.qrcode}
        alt="QR Code"
        className="my-3"
        style={{ maxWidth: 180 }}
      />
      <p className="small text-center" style={{ wordBreak: "break-word" }}>
        <strong>Or enter this secret manually:</strong>{" "}
        <i>{twoFASetup.secret}</i>
      </p>
      <TwoFAForm
        onComplete={onSubmit}
        onBack={onClose}
        userId={userId}
        isSetup={true}
      />
    </div>
  );
};

export default TwoFASetupForm;
